import {InlineLink, Button, Stack, Text} from '@primer/react-brand/esm'
import {t} from '@github-ui/swp-core/lib/utils/localization'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import styles from './CopilotCliPicker.module.css'

export function CopilotCliMobile() {
  return (
    <div className={styles.cliMobile}>
      <Stack direction="vertical" gap="normal" alignItems="center">
        <Button
          as="a"
          href="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/github/copilot-cli"
          variant="primary"
          {...getAnalyticsEvent({
            action: 'get_copilot_cli',
            tag: 'button',
            location: 'hero',
            context: 'cli_install_cta',
          })}
        >
          {t('Get Copilot CLI')}
        </Button>
        <Text as="p" size="200" variant="muted">
          <InlineLink
            href="https://docs.github.com/en/copilot/how-tos/copilot-cli/cli-best-practices"
            {...getAnalyticsEvent({
              action: 'view_docs',
              tag: 'button',
              location: 'hero',
              context: 'cli_install_cta',
            })}
          >
            {t('Read the documentation.')}
          </InlineLink>{' '}
          {t('Available with Copilot Free, Pro, Pro+, Max, Business, and Enterprise.')}
        </Text>
      </Stack>
    </div>
  )
}
